import * as getter from '../types/getters'
import * as action from '../types/actions'
import linq from 'linq'
import { classValidate } from '../../utility/validateUtility'
import Form from 'vform'
import Product from '../../models/Product'
import Paginate from '../../models/Paginate'
import { buildQuery } from '../../utility/stringUtility'
import store from '../../store'
import Color from '../../models/Color'
import Size from '../../models/Size'
import Item from '../../models/Item'

const initProductPaginate = () => {
    return {
        itemPaginate: new Paginate(null, false).setModel(new Item()).setLimit(5),
    }
}

export const state = {
    products: [],
    paginate: new Paginate(),
    product: new Product(),
    productColors: [],
    ...initProductPaginate(),
    icons: [],
}

export const mutations = {
    [action.FETCH_PRODUCTS](state, products) {
        state.products = products
    },

    [action.UPDATE_PRODUCT_PAGINATE](state, paginate) {
        state.paginate = new Paginate(paginate)
        state.paginate.auto = false
    },

    [action.CLEAR_PRODUCTS](state) {
        state.products = []
        state.paginate = new Paginate()
    },

    [action.FETCH_PRODUCT](state, product) {
        state.product = product
    },

    [action.UPDATE_PRODUCT_COLORS](state, colors) {
        state.productColors = linq
            .from(colors)
            .select((x) => new Color(x.color))
            .toArray()
    },

    [action.UPDATE_PRODUCT_ITEM_PAGINATE](state, paginate) {
        state.itemPaginate.create(paginate)
    },

    [action.CLEAR_PRODUCT](state) {
        state.product = new Product()
        const init = initProductPaginate()
        state.itemPaginate = init.itemPaginate
    },

    [action.UPDATE_ICON_MASTERS](state, icons) {
        state.icons = icons
    },
}

export const actions = {
    async [action.FETCH_PRODUCTS]({ commit }, search) {
        const query = search ? search : buildQuery(store.state.route.query)
        const { data } = await axios.get(`/api/products?${query}`)

        const products = linq
            .from(data.data)
            .select((x) => new Product(x))
            .toArray()
        commit(action.FETCH_PRODUCTS, products)
        commit(action.UPDATE_PRODUCT_PAGINATE, data)
    },

    async [action.FETCH_PRODUCTS_ALL]({ commit }) {
        const { data } = await axios.get(`/api/products`)

        const products = linq
            .from(data.data)
            .select((x) => new Product(x))
            .toArray()
        commit(action.FETCH_PRODUCTS, products)
    },

    [action.CLEAR_PRODUCTS]({ commit }) {
        commit(action.CLEAR_PRODUCTS)
    },

    async [action.FETCH_PRODUCT]({ commit }) {
        const { data } = await axios.get(`/api/product/${store.state.route.params.id}`)
        const product = new Product(data.product)
        commit(action.FETCH_PRODUCT, product)
        commit(action.UPDATE_PRODUCT_COLORS, data.colors)
        commit(action.UPDATE_PRODUCT_ITEM_PAGINATE, data.items)
        commit(action.UPDATE_ICON_MASTERS, data.icons)
    },

    async [action.FETCH_PRODUCT_ITEMS]({ commit }) {
        const { data } = await axios.get(`/api/product/${store.state.route.params.id}/items`)

        commit(action.UPDATE_PRODUCT_ITEM_PAGINATE, data)
    },

    async [action.UPDATE_PRODUCT_ITEM]({ commit }, num) {
        const { data } = await axios.get(
            `/api/product/${store.state.route.params.id}/items?page=${num}`
        )
        commit(action.UPDATE_PRODUCT_ITEM_PAGINATE, data)
    },

    async [action.SET_PRODUCT_ITEM]({ commit }, code) {
        const { data } = await axios.get(`/api/product/${store.state.route.params.id}/item/${code}`)
        commit(action.UPDATE_PRODUCT_ITEM_PAGINATE, data)
    },

    [action.CLEAR_PRODUCT]({ commit }) {
        commit(action.CLEAR_PRODUCT)
    },

    async [action.UPDATE_PRODUCT]({ commit }, product) {
        const { data } = await product.patch(`/api/product/${product.id}`)
        commit(action.FETCH_PRODUCT, new Product(data))
    },

    async [action.FETCH_PRODUCT_COLORS]({ commit }, product) {
        const { data } = await axios.get(`/api/product/${product.id}/colors`)
        commit(action.UPDATE_PRODUCT_COLORS, data)
    },

    async [action.DELETE_PRODUCT]({ commit }, product) {
        await product.delete(`/api/product/${product.id}`)
        this.dispatch(action.FETCH_PRODUCTS)
    },
}

export const getters = {
    [getter.PRODUCTS]: (state) => state.products,
    [getter.PRODUCT_PAGINATE]: (state) => state.paginate,
    [getter.PRODUCT]: (state) => state.product,
    [getter.PRODUCT_ITEM_PAGINATE]: (state) => state.itemPaginate,
    [getter.PRODUCT_COLORS]: (state) => state.productColors,
    [getter.ICON_MASTERS]: (state) => state.icons,
}

export default {
    state,
    mutations,
    actions,
    getters,
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/products.js